import React from 'react'
import { LayoutContainer } from './styled'
import { Sidebar } from '../../Sidebar'
import { Outlet } from 'react-router-dom'

export const MainLayout = () => {
  return (
    <LayoutContainer>
      <Sidebar />
      <Outlet />
    </LayoutContainer>
  )
}
